import React, { Component }  from "react";
import { Link } from "react-router-dom";
import formatLink from "../../utils/formatLink";
import axios from 'axios';
import Alert from "../../components/Alert/Alert";
import css from './FieldJobForms.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import _ from 'lodash';
import {connect} from "react-redux";

const InspectionForm = class extends Component{
    source = axios.CancelToken.source();
    pickfields = [];
    FailedInspectionSubreasonsMap = {      
        "Plans don’t match": [
            "Module placement",
            "Battery equipment placement",
            "Incorrect Wire size",
            "Incorrect AC Disconnect Size",
            "Incorrect Module",
            "Incorrect Battery",
            "Incorrect Inverter size",
            "MSP",
            "Install is wrong. Plans are correct"
        ],
        "Grounding": [
            "Ufer not verified",
            "Ground rod(s) not installed",
            "Gas/Water not bonded",
            "Equipment conduit not grounded",
            "Rails not grounded",
            "Using self tapping screws when machine screws are required"
        ],
        "Breakers": [
            "Wrong size breaker",
            "Wrong brand/type breaker",
            "Solar breaker in the wrong location in MSP/Subpanels",
            "Surge protector not installed",
            "AFCI breakers required"
        ],
        "Array wire management": [
            "Low hanging wires",
            "Wire exposure (AHJ specific)"
        ],
        "Conductor": [
            "Wrong wire size",
            "Damaged wire",
            "Plans indicate wrong size conductors"
        ],
        "Smoke and carbon monoxide detector form": [
            "Detectors not installed properly"
        ],
        "Conduit fill/Raceway": [
            "Exceeds max fill of 40%",
            "Wrong size raceway used",
            "Wrong type raceway",
            "Exceeds 30 conductors in any vertical cross section",
            "Not painted"
        ],
        "Mount": [
            "Mounts exceed plan maximum span",
            "Mounts not staggered as required",
            "Mounts not lagged into a truss",
            "Wrong mounting equipment"
        ],
        "Wrong ACD installed": [
            "Fused/ Non-fused ACD",
            "Wrong ACD rating",
            "Wrong ACD brand",
            "ACD Location"
        ],
        "Batteries": [
            "Wrong type of lag used for mounting",
            "Mount not installed per specifications",
            "Battery in wrong location per plan",
            "Battery too close to Door or Window"
        ],
        "Module": [
            "Wrong module size",
            "Wrong brand module",
            "Cantilever",
            "Fire offset"
        ],
        "Roof quality": [
            "Broken tiles"
        ],
        "Labeling": [
            "Placard",
            "Conduit",
            "Deadfront"
        ]
    };

    componentDidMount(){
        // Used to get picklist values for the below fields
        axios.get(
            '/sf/fieldjob/describeField/Inspection_Type__c;Inspection_Outcome__c;What_Was_The_Reason_For_Cancelling__c;Placard_installed__c;' +
            'Labeling_completed__c;Job_card_uploaded__c;Does_the_work_match_the_plans__c;Do_the_plans_need_to_be_revised__c;Job_card_uploaded_c__c;Failed_Inspection_Reasons__c;' +
            'What_work_was_remaining__c;Needed_for_follow_up__c;Rain_gutters_clean__c;Electrical_work_to_fix__c;Customer_knows_how_to_turn_on_system__c;Failed_Inspection_Subreasons__c',
            {
                cancelToken: this.source.token
            })
            .then((resPickFields) => {
                this.pickfields = resPickFields.data;
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
    }

    state = {
        isEditing: false,
        shouldShowAlert: false,
        Id: this.props.fieldJob.Id,
        Inspection_Outcome__c: this.props.fieldJob.Inspection_Outcome__c,
        What_Was_Partially_Completed__c: this.props.fieldJob.What_Was_Partially_Completed__c,
        What_Was_Fully_Completed__c: this.props.fieldJob.What_Was_Fully_Completed__c,
        What_Was_The_Reason_For_Cancelling__c: this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c,
        Needs_follow_up__c: this.props.fieldJob.Needs_follow_up__c,
        Job_Notes__c: this.props.fieldJob.Job_Notes__c,
        Inspection_Type__c: this.props.fieldJob.Inspection_Type__c,
        Placard_installed__c: this.props.fieldJob.Placard_installed__c,
        Labeling_completed__c: this.props.fieldJob.Labeling_completed__c,
        Job_card_uploaded__c: this.props.fieldJob.Job_card_uploaded__c,
        Does_the_work_match_the_plans__c: this.props.fieldJob.Does_the_work_match_the_plans__c,
        Do_the_plans_need_to_be_revised__c: this.props.fieldJob.Do_the_plans_need_to_be_revised__c,
        Job_card_uploaded_c__c: this.props.fieldJob.Job_card_uploaded_c__c,
        Was_the_job_ready_for_inspection__c: this.props.fieldJob.Was_the_job_ready_for_inspection__c,
        What_work_was_remaining__c: this.props.fieldJob.What_work_was_remaining__c,
        Were_you_able_to_correct_those_items__c: this.props.fieldJob.Were_you_able_to_correct_those_items__c,
        Needed_for_follow_up__c: this.props.fieldJob.Needed_for_follow_up__c,
        Roof_Type__c: this.props.fieldJob.Roof_Type__c,
        Visible_roof_damage__c: this.props.fieldJob.Visible_roof_damage__c,
        Roof_service_call_needed__c: this.props.fieldJob.Roof_service_call_needed__c,
        Describe_the_roof_damage__c: this.props.fieldJob.Describe_the_roof_damage__c,
        Rain_gutters_clean__c: this.props.fieldJob.Rain_gutters_clean__c,
        Installers_leave_work_incomplete__c: this.props.fieldJob.Installers_leave_work_incomplete__c,
        Panels_level__c: this.props.fieldJob.Panels_level__c,
        Does_system_appear_to_work__c: this.props.fieldJob.Does_system_appear_to_work__c,
        Does_system_have_S_OK__c: this.props.fieldJob.Does_system_have_S_OK__c,
        Clean_electrical_work__c: this.props.fieldJob.Clean_electrical_work__c,
        Electrical_work_to_fix__c: this.props.fieldJob.Electrical_work_to_fix__c,
        Good_workmanship__c: this.props.fieldJob.Good_workmanship__c,
        Customer_knows_how_to_turn_on_system__c: this.props.fieldJob.Customer_knows_how_to_turn_on_system__c,
        Inspection_Tech_Notes__c: this.props.fieldJob.Inspection_Tech_Notes__c,
        Customer_comments__c: this.props.fieldJob.Customer_comments__c,
        Was_sand_required_but_not_filled_in__c: this.props.fieldJob.Was_sand_required_but_not_filled_in__c,
        Failed_Inspection_Reasons__c: this.props.fieldJob.Failed_Inspection_Reasons__c,
        Failed_Inspection_Subreasons__c: this.props.fieldJob.Failed_Inspection_Subreasons__c,
    };

    saveFields = () => {
        const payload = {...this.state};

        if(this.validationSaveCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});

            delete payload.isEditing;
            delete payload.alertMessage;
            delete payload.shouldShowAlert;

            axios.put(
                '/sf/fieldjob/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
        }
    };

    endJob = () => {
        const payload = {...this.state};

        if(this.validationCompleteCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});
            delete payload.isEditing;
            delete payload.alertMessage;
            delete payload.shouldShowAlert;
            delete payload.PicklistFailed_Inspection_Reasons__c;
            delete payload.PicklistFailed_Inspection_Subreasons__c;

            payload.Clocked_End__c = moment().format(this.SF_DATE_TIME_FORMAT);
            payload.Status__c = 'Complete';
            payload.Completed_By__c = this.props.user.apiId;

            axios.put(
                '/sf/fieldjob/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
        }
    };

    validationSaveCheck = (payload) => {
        let valid = true;

        if(payload['Job_Notes__c'] !== null && payload['Job_Notes__c'].length > 5000) {
            this.setState({shouldShowAlert: true, alertMessage: 'Too Many Characters for Field Notes'})
            valid = false;
        }

        return valid;
    };

    validationCompleteCheck = (payload) => {
        let valid = true; 

        if(this.validationSaveCheck(payload)){
            if(this.state.Inspection_Outcome__c === 'Canceled') {
                if(payload['What_Was_The_Reason_For_Cancelling__c'] === null || payload['Needs_follow_up__c'] === null){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Reason for Cancellation and if Follow up is Needed'});
                    valid = false;
                }
            }

            if(this.state.Inspection_Outcome__c === 'Fail') {
                // make sure that Failed_Inspection_Reasons__c is filled in
                if(!payload['Failed_Inspection_Reasons__c']){
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Reason for Failed Inspection'});
                    valid = false;

                } else { // make sure that all reasons have subreasons selected.
                    const selectedParents = payload['Failed_Inspection_Reasons__c'].split(';');
                    const selectedChildren = payload['Failed_Inspection_Subreasons__c']?.split(';') || [];
    
                    const parentsMissingSubReasons = selectedParents.filter(parent => { // counting how many reasons that have subreasons do not have any selected.
                        const subReasons = this.FailedInspectionSubreasonsMap[parent];
                        return subReasons && subReasons.length > 0 && !subReasons.some(sub => selectedChildren.includes(sub));
                    });
    
                    if(parentsMissingSubReasons.length > 0) { // if there are reasons reasons that have subreasons but have none selected -> require user to select
                        this.setState({shouldShowAlert: true, alertMessage: 'Please select subreasons for failed inspection reasons.'});
                        valid = false;
                    }
                }
            }
        } else {
            valid = false;
        }

        return valid;
    };

    // Handles the type of field needing to be entered and will list out their values
    // Also handles updating the state of the field being passed so additional logic 
    // can be ran and the form be built for saving the fields to salesforce.
    getInput = (inputType, field, fieldProps, fieldStateOptions) => {
        switch (inputType) {
            case 'yesNo':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                );
            case 'picklist':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'multiPicklist':
                return(
                    <div className="pb-4">
                        <select onChange={(event) => this.setState({[field]: this.assignMultiple(event.target.selectedOptions)})} multiple>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'test':
                    return(fieldStateOptions.map((option) => <div key={option.value} value={option.value}>{option.label}</div>));
            case 'num':
                return(
                    <div className="pb-4">
                        <input
                            type="number"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'text':
                return(
                    <div className="pb-4">
                        <input
                            type="text"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'textarea':
                return(
                    <div className="pb-4">
                        <textarea
                            rows="5"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            default:
                return(
                    <div>
                        Not
                    </div>
                );
        };
    }

    assignMultiple = (value) => {
        const values = _.slice(value, [0], [value.length])
        const groupedValues = _.reduce(values, function(pickList, n) {
            return pickList + n.value + ';';
        }, '');

        return groupedValues;
    }

    // Creates a Double MultiPicklist Input component.
    getDoubleMultiPicklistInput = (parentField, parentStateOptions, childField, childStateOptions, parentToChildMap) => {
        let validChildValues = new Set(childStateOptions.map(option => option.value));
        
        const toggleParentSelection = (option) => {
            const selectedParents = this.state[parentField] ? this.state[parentField].split(';') : [];
        
            // option being unselected
            if(selectedParents.includes(option)) {
                const selectedChildren = this.state[childField]?.split(';');
                const parentChildOptions = parentToChildMap[option];

                if(selectedChildren && parentChildOptions){ // if there are child options, unmark all of them.
                    this.setState({[childField]: selectedChildren.filter((key) => !parentChildOptions.includes(key)).join(";")});
                }

                this.setState({[parentField]: selectedParents.filter((key) => key !== option).join(";")});

            } else { // option being selected
                this.setState({[parentField]: [...selectedParents, option].join(";")});
            }
        };

        const toggleChildSelection = (option) => {
            const selectedChildren = this.state[childField] ? this.state[childField].split(';') : [];

            // option being unselected
            if(selectedChildren.includes(option)) {
                this.setState({[childField]: selectedChildren.filter((key) => key !== option).join(";")});

            } else { // option being selected
                this.setState({[childField]: [...selectedChildren, option].join(";")});
            }
        };

        return (
            <div className={css["double-multi-picklist-container"]}>
                {parentStateOptions.map((parentOption) => { // creating parent options
                    const isParentSelected = this.state[parentField]?.includes(parentOption.value);
                    const childOptions = parentToChildMap[parentOption.value];        

                    return (
                        <div key={parentOption.value} className={css["double-multi-picklist-option"]}>
                            <label>
                                <input type="checkbox" value={parentOption.value} checked={isParentSelected || false} onChange={() => toggleParentSelection(parentOption.value)}/>
                                {parentOption.label}
                            </label>

                            {isParentSelected && childOptions && (
                                <div className={css["double-multi-picklist-options"]}>
                                    {childOptions.map((childOption) => {
                                        const isValidChild = validChildValues.has(childOption);
                                        const isChildSelected = this.state[childField]?.includes(childOption);
                                        
                                        return isValidChild ? (
                                            <div key={childOption} className={css["double-multi-picklist-option"]}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        value={childOption}
                                                        checked={isChildSelected || false}
                                                        onChange={() => toggleChildSelection(childOption)}
                                                    />
                                                    {childOption}
                                                </label>
                                            </div>
                                        ) : null;
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }

    render(){
      return (
        <div className={css.FieldJobForms}>
            <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage} <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({shouldShowAlert: false, alertMessage: ''})} /></Alert>
            <div className="d-flex justify-content-between mt-5 mb-4">

                {/* Header of Field Job Form and includes buttons to End Job and Save */}
                <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                    <button className="btn btn-outline" type="button">Back</button>
                </Link>

                <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                    <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                    <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                </div>

                <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                    <a
                        href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button className="btn btn-outline">Upload</button>
                    </a>
                    <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                </div>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
            </div>

            {
                this.state.isEditing ?

                // Render when editing
                <div className="text-white">
                    <h2 className="pt-4">Inspection Field Job</h2>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Inspection Type *</label>
                        {this.getInput('picklist', 'Inspection_Type__c', this.state.Inspection_Type__c, this.pickfields.Inspection_Type__c.picklistValues)}
                    </div>

                    <div>
                        <label htmlFor="Inspection_Outcome__c">Inspection Outcome *</label>
                        {this.getInput('picklist', 'Inspection_Outcome__c', this.state.Inspection_Outcome__c, this.pickfields.Inspection_Outcome__c.picklistValues)}
                    </div>

                    {/* For When Field Job Is Cancelled */}

                    <div className={this.state.Inspection_Outcome__c === 'Canceled' ? '' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What Was The Reason For Cancelling? *</label>
                            {this.getInput('picklist', 'What_Was_The_Reason_For_Cancelling__c', this.state.What_Was_The_Reason_For_Cancelling__c, this.pickfields.What_Was_The_Reason_For_Cancelling__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Follow up and service call required? *</label>
                            {this.getInput('yesNo', 'Needs_follow_up__c', this.state.Needs_follow_up__c)}
                        </div>

                        <h2 className="pt-4">Field Notes</h2>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Field Notes</label>
                            {this.getInput('textarea', 'Job_Notes__c', this.state.Job_Notes__c)}
                        </div>
                    </div>

                    {/* End of For When Field Job Is Cancelled */}

                    {/* Additional Field for When Inspection Fails */}

                    <div className={this.state.Inspection_Outcome__c === 'Fail' ? '' : 'd-none'}>
                        <div> 
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Failed Inspection Reasons *</label>
                            {this.getDoubleMultiPicklistInput('Failed_Inspection_Reasons__c', this.pickfields.Failed_Inspection_Reasons__c.picklistValues, 'Failed_Inspection_Subreasons__c', 
                                                                this.pickfields.Failed_Inspection_Subreasons__c.picklistValues, this.FailedInspectionSubreasonsMap)}
                        </div>
                        <div className={this.state.Inspection_Type__c === 'Trench (Not Final)' || this.state.Inspection_Type__c === 'Ground Mount' ? '' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Was sand required but not filled in?</label>
                                {this.getInput('yesNo', 'Was_sand_required_but_not_filled_in__c', this.state.Was_sand_required_but_not_filled_in__c)}
                            </div>
                        </div>
                    </div>

                    {/* End of For When Field Job Is Cancelled */}

                    <div className={this.state.Inspection_Outcome__c !== 'Canceled' ? '' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Placard Installed?</label>
                            {this.getInput('picklist', 'Placard_installed__c', this.state.Placard_installed__c, this.pickfields.Placard_installed__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Labeling Completed?</label>
                            {this.getInput('picklist', 'Labeling_completed__c', this.state.Labeling_completed__c, this.pickfields.Labeling_completed__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Job Card Uploaded?</label>
                            {this.getInput('picklist', 'Job_card_uploaded__c', this.state.Job_card_uploaded__c, this.pickfields.Job_card_uploaded__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Does the work match the plans?</label>
                            {this.getInput('picklist', 'Does_the_work_match_the_plans__c', this.state.Does_the_work_match_the_plans__c, this.pickfields.Does_the_work_match_the_plans__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Do the plans need to be revised?</label>
                            {this.getInput('yesNo', 'Do_the_plans_need_to_be_revised__c', this.state.Do_the_plans_need_to_be_revised__c)}
                        </div>
                        <div className={this.state.Do_the_plans_need_to_be_revised__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Do the revised plans need to be submitted?</label>
                                {this.getInput('picklist', 'Job_card_uploaded_c__c', this.state.Job_card_uploaded_c__c, this.pickfields.Job_card_uploaded_c__c.picklistValues)}
                            </div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Was the job ready for inspection?</label>
                            {this.getInput('yesNo', 'Was_the_job_ready_for_inspection__c', this.state.Was_the_job_ready_for_inspection__c)}
                        </div>
                        <div className={this.state.Was_the_job_ready_for_inspection__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What work was remaining? (Select All That Apply)</label>
                                {this.getInput('multiPicklist', 'What_work_was_remaining__c', this.state.What_work_was_remaining__c, this.pickfields.What_work_was_remaining__c.picklistValues)}
                            </div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Were you able to correct those items?</label>
                            {this.getInput('yesNo', 'Were_you_able_to_correct_those_items__c', this.state.Were_you_able_to_correct_those_items__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Follow up and service call required?</label>
                            {this.getInput('yesNo', 'Needs_follow_up__c', this.state.Needs_follow_up__c)}
                        </div>
                        <div className={this.state.Needs_follow_up__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Who is needed for follow up? (Select All That Apply)</label>
                                {this.getInput('multiPicklist', 'Needed_for_follow_up__c', this.state.Needed_for_follow_up__c, this.pickfields.Needed_for_follow_up__c.picklistValues)}
                            </div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Roof Type</label>
                            <select id={this.state.Roof_Type__c} onChange={(event) => this.setState({Roof_Type__c: event.target.value})}>
                                <option value=""></option>
                                <option value="Comp Shingle">Comp</option>
                                <option value="Flat Tile">Tile</option>
                                <option value="Rolled Comp">Flat</option>
                                <option value="Sheet Metal">Metal</option>
                            </select>
                        </div>
                        <div className={this.state.Roof_Type__c === 'Comp Shingle' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Is everything properly flashed/sealed?</label>
                                <div className="pb-4">
                                    <select id={this.state.Visible_roof_damage__c} onChange={(event) => this.setState({Visible_roof_damage__c: event.target.value, Roof_service_call_needed__c: event.target.value})}>
                                        <option disabled value=""></option>
                                        <option value="No">Yes</option>
                                        <option value="Yes">No</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.Roof_Type__c === 'Flat Tile' || this.state.Roof_Type__c === 'W-Tile' || this.state.Roof_Type__c === 'S-Tile' || this.state.Roof_Type__c === 'Spanish/Clay Tile' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Is tile replacement properly installed?</label>
                                <div className="pb-4">
                                    <select id={this.state.Visible_roof_damage__c} onChange={(event) => this.setState({Visible_roof_damage__c: event.target.value, Roof_service_call_needed__c: event.target.value})}>
                                        <option disabled value=""></option>
                                        <option value="No">Yes</option>
                                        <option value="Yes">No</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.Roof_Type__c === 'Sheet Metal' || this.state.Roof_Type__c === 'Metal Tile' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Is there obvious damage?</label>
                                <div className="pb-4">
                                    <select id={this.state.Visible_roof_damage__c} onChange={(event) => this.setState({Visible_roof_damage__c: event.target.value, Roof_service_call_needed__c: event.target.value})}>
                                        <option disabled value=""></option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.Roof_Type__c === 'Rolled Comp' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Do E-curbs appear to be installed correctly and water tight?</label>
                                <div className="pb-4">
                                    <select id={this.state.Visible_roof_damage__c} onChange={(event) => this.setState({Visible_roof_damage__c: event.target.value, Roof_service_call_needed__c: event.target.value})}>
                                        <option disabled value=""></option>
                                        <option value="No">Yes</option>
                                        <option value="Yes">No</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.Visible_roof_damage__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Describe the roof damage</label>
                                {this.getInput('textarea', 'Describe_the_roof_damage__c', this.state.Describe_the_roof_damage__c)}
                            </div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Rain gutters clean of trash/debris?</label>
                            {this.getInput('picklist', 'Rain_gutters_clean__c', this.state.Rain_gutters_clean__c, this.pickfields.Rain_gutters_clean__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Did the installers leave work that could have been completed at install?</label>
                            {this.getInput('yesNo', 'Installers_leave_work_incomplete__c', this.state.Installers_leave_work_incomplete__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Panels square/level as roof would allow?</label>
                            {this.getInput('yesNo', 'Panels_level__c', this.state.Panels_level__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Does the system appear to be operational?</label>
                            {this.getInput('yesNo', 'Does_system_appear_to_work__c', this.state.Does_system_appear_to_work__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">If you logged into the inverter, does it have S-OK?</label>
                            {this.getInput('yesNo', 'Does_system_have_S_OK__c', this.state.Does_system_have_S_OK__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Clean electrical work?</label>
                            {this.getInput('yesNo', 'Clean_electrical_work__c', this.state.Clean_electrical_work__c)}
                        </div>
                        <div className={this.state.Clean_electrical_work__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Electrical work to fix</label>
                                {this.getInput('multiPicklist', 'Electrical_work_to_fix__c', this.state.Electrical_work_to_fix__c, this.pickfields.Electrical_work_to_fix__c.picklistValues)}
                            </div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Good workmanship?</label>
                            {this.getInput('yesNo', 'Good_workmanship__c', this.state.Good_workmanship__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Was the customer instructed on how to turn on/off?</label>
                            {this.getInput('picklist', 'Customer_knows_how_to_turn_on_system__c', this.state.Customer_knows_how_to_turn_on_system__c, this.pickfields.Customer_knows_how_to_turn_on_system__c.picklistValues)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Inspection Tech Notes:</label>
                            {this.getInput('textarea', 'Inspection_Tech_Notes__c', this.state.Inspection_Tech_Notes__c)}
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Customer Comments:</label>
                            {this.getInput('textarea', 'Customer_comments__c', this.state.Customer_comments__c)}
                        </div>
                    </div>
                </div>

                :

                // Render when not editing
                <div className="text-white">
                    <h2 className="pt-4">Inspection Field Job</h2>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Inspection Type</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Inspection_Type__c ? this.props.fieldJob.Inspection_Type__c : '---'}</div>
                    </div>

                    <label className="col-sm-5 col-12 m-0 py-2">Inspection Outcome</label>
                    <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Inspection_Outcome__c ? this.props.fieldJob.Inspection_Outcome__c : '---'}</div>

                    {/* Shown when Canceled */}
                    <div className={this.state.Inspection_Outcome__c === 'Canceled' ? '' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">What Was The Reason For Cancelling?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c ? this.props.fieldJob.What_Was_The_Reason_For_Cancelling__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Follow up Needed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Needs_follow_up__c ? this.props.fieldJob.Needs_follow_up__c : '---'}</div>
                        </div>

                        <h2 className="pt-4">Field Notes</h2>
                        <div>
                            <label className="text-white col-sm-5 col-6 m-0 py-2">Field Notes</label>
                            <div className={this.props.fieldJob.Job_Notes__c ? "col-12" : "d-inline col-sm-7 col-12"}>{this.props.fieldJob.Job_Notes__c ? this.props.fieldJob.Job_Notes__c : '---'}</div>
                        </div>
                    </div>

                    {/* Shown when Failed */}
                    <div className={this.state.Inspection_Outcome__c === 'Fail' ? '' : 'd-none'}>
                        <div> 
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Failed Inspection Reasons</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Failed_Inspection_Reasons__c ? this.props.fieldJob.Failed_Inspection_Reasons__c.replaceAll(";", "; ") : '---'}</div>
                        </div>
                        <div> 
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Failed Inspection Sub-Reasons</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Failed_Inspection_Subreasons__c ? this.props.fieldJob.Failed_Inspection_Subreasons__c.replaceAll(";", "; ") : '---'}</div>
                        </div>
                        <div className={this.state.Inspection_Type__c === 'Trench (Not Final)' || this.state.Inspection_Type__c === 'Ground Mount' ? '' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Was sand required but not filled in?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Was_sand_required_but_not_filled_in__c ? this.props.fieldJob.Was_sand_required_but_not_filled_in__c : '---'}</div>
                            </div>
                        </div>
                    </div>

                    <div className={this.state.Inspection_Outcome__c !== 'Canceled' ? '' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Placard Installd?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Placard_installed__c ? this.props.fieldJob.Placard_installed__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Labeling Completed?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Labeling_completed__c ? this.props.fieldJob.Labeling_completed__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Job Card Uploaded?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Job_card_uploaded__c ? this.props.fieldJob.Job_card_uploaded__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Does the work match the plans?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Does_the_work_match_the_plans__c ? this.props.fieldJob.Does_the_work_match_the_plans__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Do the plans need to be revised?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Do_the_plans_need_to_be_revised__c ? this.props.fieldJob.Do_the_plans_need_to_be_revised__c : '---'}</div>
                        </div>
                        <div className={this.props.fieldJob.Do_the_plans_need_to_be_revised__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Do the revised plans need to be submitted?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Job_card_uploaded_c__c ? this.props.fieldJob.Job_card_uploaded_c__c : '---'}</div>
                            </div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Was the job ready for inspection?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Was_the_job_ready_for_inspection__c ? this.props.fieldJob.Was_the_job_ready_for_inspection__c : '---'}</div>
                        </div>
                        <div className={this.props.fieldJob.Was_the_job_ready_for_inspection__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">What work was remaining?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_work_was_remaining__c ? this.props.fieldJob.What_work_was_remaining__c : '---'}</div>
                            </div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Were you able to correct those items?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Were_you_able_to_correct_those_items__c ? this.props.fieldJob.Were_you_able_to_correct_those_items__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Follow up and service call required?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Needs_follow_up__c ? this.props.fieldJob.Needs_follow_up__c : '---'}</div>
                        </div>
                        <div className={this.props.fieldJob.Needs_follow_up__c === 'Yes' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Who is needed for follow up?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Needed_for_follow_up__c ? this.props.fieldJob.Needed_for_follow_up__c : '---'}</div>
                            </div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Roof Type</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Roof_Type__c ? this.props.fieldJob.Roof_Type__c : '---'}</div>
                        </div>
                        <div className={this.state.Roof_Type__c === 'Comp Shingle' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Is everything properly flashed/sealed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Visible_roof_damage__c ? this.props.fieldJob.Visible_roof_damage__c : '---'}</div>
                            </div>
                        </div>
                        <div className={this.state.Roof_Type__c === 'Flat Tile' || this.state.Roof_Type__c === 'W-Tile' || this.state.Roof_Type__c === 'S-Tile' || this.state.Roof_Type__c === 'Spanish/Clay Tile' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Is tile replacement properly installed?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Visible_roof_damage__c ? this.props.fieldJob.Visible_roof_damage__c : '---'}</div>
                            </div>
                        </div>
                        <div className={this.state.Roof_Type__c === 'Sheet Metal' || this.state.Roof_Type__c === 'Metal Tile' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Is there obvious damage?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Visible_roof_damage__c ? this.props.fieldJob.Visible_roof_damage__c : '---'}</div>
                            </div>
                        </div>
                        <div className={this.state.Roof_Type__c === 'Rolled Comp' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Do E-curbs appear to be installed correctly and water tight?</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Visible_roof_damage__c ? this.props.fieldJob.Visible_roof_damage__c : '---'}</div>
                            </div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Rain gutters clean of trash/debris?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Rain_gutters_clean__c ? this.props.fieldJob.Rain_gutters_clean__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Did the installers leave work that could have been completed at install?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Installers_leave_work_incomplete__c ? this.props.fieldJob.Installers_leave_work_incomplete__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Panels square/level as roof would allow?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Panels_level__c ? this.props.fieldJob.Panels_level__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Does the system appear to be operational?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Does_system_appear_to_work__c ? this.props.fieldJob.Does_system_appear_to_work__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">If you logged into the inverter, does it have S-OK?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Does_system_have_S_OK__c ? this.props.fieldJob.Does_system_have_S_OK__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Clean electrical work?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Clean_electrical_work__c ? this.props.fieldJob.Clean_electrical_work__c : '---'}</div>
                        </div>
                        <div className={this.state.Clean_electrical_work__c === 'No' ? 'mt-0' : 'd-none'}>
                            <div>
                                <label className="text-white col-sm-5 col-12 m-0 py-2">Electrical work to fix</label>
                                <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Electrical_work_to_fix__c ? this.props.fieldJob.Electrical_work_to_fix__c : '---'}</div>
                            </div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Good workmanship?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Good_workmanship__c ? this.props.fieldJob.Good_workmanship__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Was the customer instructed on how to turn on/off?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Customer_knows_how_to_turn_on_system__c ? this.props.fieldJob.Customer_knows_how_to_turn_on_system__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Inspection Tech Notes:</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Inspection_Tech_Notes__c ? this.props.fieldJob.Inspection_Tech_Notes__c : '---'}</div>
                        </div>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Customer Comments:</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Customer_comments__c ? this.props.fieldJob.Customer_comments__c : '---'}</div>
                        </div>
                    </div>
                </div>
            }

            {/* Footer of Field Job Form that includs the buttons for Endind and Saving Job */}
            <div className="mt-5 mb-4">
                <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                    <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
                </div>

                <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                    <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
                </div>
                <div className="d-flex justify-content-between mt-3">
                    {/* the ternary expression prevents user from clicking the link before `schedulableId` has been fetched: */}
                    <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                        <button className="btn btn-outline" type="button">Back</button>
                    </Link>

                    <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                        <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                        <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                    </div>

                    <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                        <a
                            href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn btn-outline">Upload</button>
                        </a>
                        <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                    </div>

                </div>
            </div>

        </div>
    )};
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(InspectionForm);